export default "__VITE_ASSET__1511b93e__"